import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Font, Hyperlink, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  content: {
    flex: 1,
  },
  change: {},
  changeText: {
    flex: 1,
    fontFamily: Font.medium,
  },
})

interface Props extends ViewProps {
  text?: string | ReactElement
  onChange?: () => void
}

const ProfileChange = (props: Props) => {
  const { text, onChange, style, ...otherProps } = props
  const { t } = useTranslation()

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.content}>{typeof text === 'string' ? <Text>{text}</Text> : text}</View>
      <Hyperlink
        title={t('Change')}
        style={styles.change}
        textStyle={styles.changeText}
        onPress={onChange}
        testID="ProfileChange.Change"
      />
    </View>
  )
}

export default ProfileChange
